import { useMutation } from "@tanstack/react-query";

import { toast } from "@/components/ui/use-toast";
import { apiClient } from "@/lib/api/client";
import { handleApiError } from "@/lib/api/error";
import { useTranslation } from "@/lib/i18n";
import { queryClient } from "@/lib/queryClient";
// TODO: domainがRouteの依存を持つのは避けたい。domain内部でkeyを管理するようにする
import { appIntegrationKey } from "@/routes/_staff/app-integrations/$id/_$id/-query/key";
import { softwareKey } from "@/routes/_staff/software/$id/_$id/-query/key";

type Options = {
  appIntegrationId: string;
  appUserId: string;
  onSuccess?: () => void;
  /** softwareIdが指定された場合、software用のエンドポイントを使用 */
  softwareId?: string;
};

export default function useAppUserChangeWorker({
  appIntegrationId,
  appUserId,
  onSuccess,
  softwareId,
}: Options) {
  const { i18n } = useTranslation();

  return useMutation({
    mutationFn: async (personId: string) => {
      // softwareIdが指定されている場合はsoftware用のエンドポイントを使用
      if (softwareId) {
        const save = await apiClient.PUT(
          "/v2/software/{softwareId}/users/{appUserId}/worker",
          {
            params: { path: { softwareId, appUserId } },
            body: { personId },
          },
        );
        return save;
      }

      // 従来のapp-integrations用エンドポイント
      const save = await apiClient.PUT(
        "/v3/app-integrations/{id}/users/{appUserId}/worker",
        {
          params: { path: { id: appIntegrationId, appUserId } },
          body: { personId },
        },
      );
      return save;
    },
    onSuccess: async () => {
      // softwareIdが指定されている場合はsoftwareのキャッシュを無効化
      const queryKey = softwareId
        ? softwareKey.all(softwareId)
        : appIntegrationKey.all(appIntegrationId);

      await queryClient.invalidateQueries({ queryKey });

      // TODO:Alertのキーを確認する
      await queryClient.invalidateQueries({
        queryKey: ["alerts"],
      });
      toast({ title: "Success!!" });
      onSuccess?.();
    },
    onError: (error) => {
      const { message } = handleApiError(error, {
        language: i18n.language,
      });
      toast({ title: message });
    },
  });
}
